module.exports = __webpack_public_path__ + "assets/3e5cdd4f7ca230f3808ec3faa0bf4107.png";